// 3. Composant pour la gestion des erreurs/succès
// components/consultation/StatusMessages.tsx
import React from 'react';

interface StatusMessagesProps {
  loading: boolean;
  error: string | null;
  success: boolean;
}

export const StatusMessages: React.FC<StatusMessagesProps> = ({ 
  loading, 
  error, 
  success 
}) => {
  if (loading) {
    return (
      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-700">
          Enregistrement de la consultation en cours...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
        <p className="text-sm text-red-700">Erreur: {error}</p>
      </div>
    );
  }

  if (success && !loading) {
    return (
      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
        <p className="text-sm text-green-700">
          Consultation enregistrée avec succès!
        </p>
      </div>
    );
  }

  return null;
};
